var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideo02 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 40,
  fill: "none",
  viewBox: "0 0 16 10",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.333 5.977c0-.318 0-.477.067-.566a.33.33 0 0 1 .243-.133c.11-.008.244.078.512.25l3.147 2.023c.232.15.349.224.389.32a.33.33 0 0 1 0 .259c-.04.095-.157.17-.389.319l-3.147 2.023c-.268.172-.401.258-.512.25a.33.33 0 0 1-.243-.133c-.067-.089-.067-.248-.067-.566z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideo02);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video02.5b632b39c3e842c8bf3b119f7a8773c2.svg";